export enum QuestionDifficulty {
  Basic = 'basic',
  Advanced = 'advanced',
  Excellence = 'excellence'
}

export enum AnswerStatus {
  Positive = 'positive',
  Negative = 'negative',
  NotAvailable = 'notAvailable',
  Empty = 'empty'
}

export interface DifficultSummary {
  answeredPositively: number
  questionCount: number
  positivePercent: number
}

export type DifficultySummaries = Record<QuestionDifficulty, DifficultSummary>

export interface Scoring {
  score: number
  completion: number
  difficultySummaries: DifficultySummaries
}
